import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpHeaders
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { MethodCall } from '@angular/compiler';
import { environment } from 'src/environments/environment';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // if (request.method === 'GET') {
    //   const headers = new HttpHeaders({
    //     'Content-Type': 'application/json'
    //   });
    //   console.log('url: ' + request.url);
    //   const reqClone = request.clone({
    //     headers,
    //   });
    //   return next.handle(reqClone);
    // }

    return next.handle(request);
  }
}
